import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { ProviderIcon } from "@/components/ProviderIcons";

/**
 * OAuthButtons - dynamically renders a "Continue with X" button for every
 * OAuth provider enabled on the backend (GET /api/auth/providers).
 *
 * When a new provider is added on the server, the buttons appear here automatically.
 */
export default function OAuthButtons({ testidPrefix = "auth" }) {
  const [providers, setProviders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/auth/providers");
        setProviders(data.providers || []);
      } catch {
        setProviders([]);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const startLogin = (name) => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/auth/callback";
    if (name === "emergent_google") {
      window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
      return;
    }
    // Future providers will use provider-specific start URLs, e.g.
    // window.location.href = `https://accounts.microsoft.com/...?redirect_uri=${...}`;
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  if (loading) {
    return (
      <div className="w-full h-11 rounded-lg bg-zinc-900/60 border border-zinc-800 animate-pulse mb-5" />
    );
  }

  if (providers.length === 0) return null;

  return (
    <div className="space-y-2 mb-5">
      {providers.map((p) => (
        <button
          key={p.name}
          type="button"
          data-testid={`${testidPrefix}-provider-${p.name}`}
          onClick={() => startLogin(p.name)}
          className="w-full inline-flex items-center justify-center gap-2 bg-zinc-50 text-zinc-950 hover:bg-white font-medium rounded-lg px-4 py-2.5 transition-colors"
        >
          <ProviderIcon icon={p.icon} />
          {p.display_name}
        </button>
      ))}
    </div>
  );
}
